import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const usePeoplePickerStyles = makeStyles({
  container: {
    minWidth: "100%",
  },
  tagGroup: {
    maxHeight: "80px",
    overflowY: "auto" as const,
    flexWrap: "wrap",
  },
  selectionContainer: {
    maxHeight: "min(200px, 40vh)",
    height: "fit-content",
    overflowY: "auto",
    overflowX: "hidden",
  },
  truncatedText: {
    whiteSpace: "nowrap",
    overflowX: "hidden",
    textOverflow: "ellipsis",
  },
  optionText: {
    fontSize: designTokens.fontSize.sm,
    whiteSpace: "nowrap",
    overflowX: "hidden",
    textOverflow: "ellipsis",
  },
  secondaryText: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    whiteSpace: "nowrap",
    overflowX: "hidden",
    textOverflow: "ellipsis",
  },
});
